/**
 * expandToCell.ts - Grow the table so it contains a ghost-cell index.
 */

import type {Cell} from 'notebook/tables/constants/CellConstants';
import type {TableIndex} from 'notebook/tables/constants/TableSelectionConstants';
import {computeExpandedToCellTable} from 'notebook/tables/store/logic/interactions/tableInteractionLogic';
import type {TableMutationParams} from 'notebook/tables/store/logic/mutations/mutationParams';
import {persistTable} from 'notebook/tables/store/logic/mutations/mutationParams';
import {saveSelection} from 'notebook/tables/store/logic/mutations/selection';

/**
 * Grow the table until it contains `index` (typically a ghost cell) and return the cell now at that
 * index.
 *
 * Checkpoints `index` as the selection for undo before persisting. Must not be called on a table with
 * locked dimensions.
 */
export function expandToCell(params: TableMutationParams, index: TableIndex): Cell {
  const {table} = params.getTableProps();
  const expanded = computeExpandedToCellTable(table, index);
  saveSelection(params, {multiStartIndex: index, multiEndIndex: index, multiSelIndex: index});
  persistTable(params, expanded);
  return expanded.cell;
}
